__turbopack_context__.v({
  "className": "publicserif_c2298270-module__VkHmUq__className",
  "variable": "publicserif_c2298270-module__VkHmUq__variable",
});
